const featureToggles = {
    executiveDashBoardAnalysisOff: false,
    executiveDashBoardDesignProgress: false,
};

export default featureToggles;
